import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions } from '../../reducers/actions';
import { UserService } from '../../services';
import { editedSiteUserAction } from '../../reducers/actions';
import { apiErrorHandling } from '../../utils/epics/apiErrorHandling';
import updateErrorMsgAction from '../../reducers/error-banner/actions/updateErrorMsg';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_USER),
    switchMap(action =>
      UserService.edit(action.user, store).pipe(
        map(() => editedSiteUserAction(action.user)),
        catchError(apiErrorHandling(updateErrorMsgAction))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/users/editUser.js